import $ from 'cash-dom';

let instance = null;

/**
 * Class Settings contains website settings. Please add more settings if needed.
 */
class Settings {
	constructor() {
		if (!instance) {
			this._currentWebsiteId = $('body').data('current-website-id');

			instance = this;
		}

		return instance;
	}

	static getInstance() {
		if (!Settings._instance) {
			Settings._instance = new Settings();
		}

		return Settings._instance;
	}

	static get CURREN_WEBSITE_ID() {
		return this.getInstance()._currentWebsiteId;
	}
}

export default Settings;
